import { useCallback } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import mapBg from 'shared/images/map-bg.png'
import { ImageOptimized } from 'shared/ui/image-optimized'
import { Loader } from 'shared/ui/loader'
import { useMap } from 'shared/ui/map/libs'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface MapSectionProps {
  title: string
  latitude: number
  longitude: number
  onOpenFullMap?: () => void
}

export const MapSection = ({
  title,
  latitude,
  longitude,
  onOpenFullMap,
}: MapSectionProps) => {
  const { t } = useTranslation()

  const { isMapLoading, mapRef } = useMap({
    center: { latitude, longitude },
    markers: [
      {
        latitude,
        longitude,
        title,
      },
    ],
    errorMessage: 'kyrgyzstan_block.detail.map_error',
    disableZoom: true,
  })

  const handleOpenFullMap = useCallback(() => {
    onOpenFullMap?.()
  }, [onOpenFullMap])

  return (
    <Paper
      padding={[12, 14, 14]}
      radius="16"
    >
      <h2 className={clsx('semi-bold-16', s.mapTitle)}>
        {t('kyrgyzstan_block.detail.on_map')}
      </h2>

      <div
        className={s.mapWrapper}
        onClick={handleOpenFullMap}
      >
        <div
          className={s.map}
          ref={mapRef}
        />

        {isMapLoading && (
          <div className={s.loadingOverlay}>
            <ImageOptimized
              src={mapBg}
              alt=""
              className={s.mapBg}
            />
            <Loader />
          </div>
        )}
      </div>
    </Paper>
  )
}
